import { Component } from 'react';
import TweenMax from 'gsap/TweenMax';
import animationFunctionality from './animation-functionality/index';
import { AnimationType } from 'types/enums';

class Animation extends Component<any> {
  _container: any;
  constructor(props) {
    super(props);

    this._container = null;
    this.prepareAnimation = this.prepareAnimation.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.started && this.props.started && this.props.active) {
      this.animate();
    }

    if (
      prevProps.started &&
      !this.props.started &&
      this.props.type !== AnimationType.LONG_SWIM
    ) {
      this.resetTransformState();
    }

    if (
      prevProps.started &&
      !this.props.started &&
      !this.props.done &&
      this.props.type === AnimationType.LONG_SWIM
    ) {
      this.resetTransformState();
      animationFunctionality.longSwim.resetAnimationData();
    }

    // if (!prevProps.done && this.props.done) {
    //   this.hide();
    // }
  }

  // TODO: remove comments, when the animation func is done
  // hide() {
  //   TweenMax.to(this._container, 0.5, {
  //     opacity: 0
  //   });
  // }

  resetTransformState() {
    if (this.props.type !== AnimationType.BASEBALL) {
      TweenMax.to(this._container, 0.5, {
        opacity: 0,
        onComplete: () => {
          TweenMax.set(this._container, {
            opacity: 0,
            rotation: 0,
            x: 0,
            y: 0,
          });
        },
      });
    } else {
      TweenMax.set(this._container, {
        opacity: 0,
        rotation: 0,
        x: 0,
        y: 0,
      });
    }
  }

  prepareAnimation(initialX, initialY) {
    TweenMax.set(this._container, {
      x: initialX,
      y: initialY,
    });
  }

  animate() {
    if (this.props.type === AnimationType.LONG_SWIM) {
      animationFunctionality.longSwim.animate(
        this._container,
        this.props.canvas,
        this.props.duration,
        this.prepareAnimation
      );
    } else {
      animationFunctionality[this.props.type](
        this._container,
        this.props.canvas,
        this.props.duration,
        this.prepareAnimation,
        this.props.onComplete
      );
    }
  }

  render() {
    return (
      <div
        className={`animation ${this.props.type}`}
        ref={(divEl) => (this._container = divEl)}
      >
        {this.props.children}
      </div>
    );
  }
}

export default Animation;
